import * as React from 'react';

const RegistrationDocIcon = () => (
  <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M10 14.0001H22" stroke="#00AED9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  <path d="M10 18.0001H22" stroke="#00AED9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  <path d="M10 22.0001H16" stroke="#00AED9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  <path d="M25 29.003H7C5.89543 29.003 5 28.1076 5 27.003V5.00299C5 3.89842 5.89543 3.00299 7 3.00299H19.7574C20.2878 3.00299 20.7965 3.2137 21.1716 3.58878L26.4142 8.83142C26.7893 9.20649 27 9.7152 27 10.2456V27.003C27 28.1076 26.1046 29.003 25 29.003Z" stroke="#00619E" strokeWidth="2"/>
  <path d="M21 4.00299V8.00299C21 8.55528 21.4477 9.00299 22 9.00299H26" stroke="#00619E" strokeWidth="2"/>
  </svg>
);

export default RegistrationDocIcon;
